module.exports = ".footer {\n  background-color: #f4f4f4;\n  color: #FF0000;\n  border-top: 1px solid silver; }\n\n.col-12 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\np {\n  margin: auto;\n  padding: 1%; }\n\n@media all and (max-width: 426px) {\n  p {\n    font-size: 11px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = ./src/app/footer/footer.component.scss
// module chunks = main